import { 
	useBlockProps,
	__experimentalGetBorderClassesAndStyles as getBorderClassesAndStyles,
	__experimentalGetColorClassesAndStyles as getColorClassesAndStyles,
	__experimentalGetSpacingClassesAndStyles as getSpacingClassesAndStyles
} from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const {attributes} = props;
	const borderProps = getBorderClassesAndStyles( attributes );
	const colorProps = getColorClassesAndStyles( attributes );
	const spacingProps = getSpacingClassesAndStyles( attributes );
	const customStyle = {
		height: `${attributes.height}px`,
		width: `${attributes.width}px`,
	}

	const separatorStyle = {
		...borderProps.style, // Default border styles
		...colorProps.style,  // Default color styles
		...spacingProps.style,  // Default spacing styles
		...customStyle,
	};

	return (
		<div {...useBlockProps.save({ className: "wpopus-advanced-separator" })}
			style = { separatorStyle }
		>
		</div>
	);
}
